import React, { useState } from "react";
import PropTypes from "prop-types";
import { useAppTranslation } from "../../../../i18n/useAppTranslation";
import { ConfirmModal } from "../../../../boxes/ConfirmModal/ConfirmModal";
import { useDeleteInvoiceMutation } from "../../../../api/mutations/useDeleteInvoiceMutation";
import { uiNotification } from "../../../../services/UINotificationService";
import { passOr } from "../../../../utilities/general";
import { CircularProgress } from "../../../../shared/CircularProgress/CircularProgress";
import { history } from "../../../../history";
import classes from "./DeleteInvoice.module.scss";
import { extractApiError } from "../../../../utilities/api";
import { usePermission } from "../../../../hooks/usePermission";
import { PERMISSIONS } from "../../../../consts/api";
import { useCurrentAccountQuery } from "../../../../api/queries/useAccountQuery";

export function DeleteInvoice({ invoiceId, patientId, takePaymentRoute }) {
  const { tCommon } = useAppTranslation.Common();
  const { tSales } = useAppTranslation.Sales();
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const viewInvoicesPermission = usePermission(PERMISSIONS.viewSalesInvoices);
  const { data: accountData } = useCurrentAccountQuery();

  const deleteInvoice = useDeleteInvoiceMutation({
    onError: (e) => {
      const errorKey = extractApiError(e);
      uiNotification.error(
        tSales(`invoicePreview.apiError.deleteInvoice.${errorKey}`),
      );
    },
    onSuccess: () => {
      history.goBack();
      uiNotification.success(tSales("invoicePreview.apiSuccess.deleteInvoice"));
    },
  });

  const onDelete = () => {
    if (invoiceId && patientId) {
      setIsConfirmModalOpen(false);
      deleteInvoice.mutate({
        invoiceId: Number(invoiceId),
        patientId: Number(patientId),
      });
    }
  };
  const onTakePayment = () => {
    window.location.href = takePaymentRoute;
  };

  const canViewInvoices =
    viewInvoicesPermission.loaded && viewInvoicesPermission.permitted;

  return canViewInvoices ? (
    <div className={classes.root}>
      {takePaymentRoute && (
        <div>
          {accountData?.isPosEnabled && (
            <button className="blue-btn" onClick={() => onTakePayment()}>
              Take Payment
            </button>
          )}
        </div>
      )}
      <button
        onClick={() => setIsConfirmModalOpen(true)}
        disabled={deleteInvoice.isLoading}
        className="red-btn d-flex align-center justify-center gap-4"
      >
        {passOr(deleteInvoice.isLoading, undefined, () => (
          <CircularProgress color="white" size="tiny" />
        ))}
        {tCommon("label.delete")}
      </button>
      <ConfirmModal
        isOpen={isConfirmModalOpen}
        onCancel={() => setIsConfirmModalOpen(false)}
        onClose={() => setIsConfirmModalOpen(false)}
        onConfirm={onDelete}
      >
        {tCommon("confirm.deleteInvoice")}
      </ConfirmModal>
    </div>
  ) : null;
}

DeleteInvoice.propTypes = {
  invoiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

DeleteInvoice.defaultProps = {
  invoiceId: null,
  patientId: null,
};
